export const SEND_EMAILS = "send-emails/SEND__EMAILS";
export const SEND_EMAILS_SUCCESS = "send-emails/SEND_EMAILS_SUCCESS";
export const SEND_EMAILS_FAILED = "send-emails/SEND_EMAILS_FAILED";
export const CLEAR_SEND_EMAIL_STATE = "send-emails/CLEAR_SEND_EMAIL_STATE";

export const SEND_WEEKLY_EMAILS = "send-emails/SEND_WEEKLY_EMAILS";
export const SEND_WEEKLY_EMAILS_SUCCESS =
  "send-emails/SEND_WEEKLY_EMAILS_SUCCESS";
export const SEND_WEEKLY_EMAILS_FAILED =
  "send-emails/SEND_WEEKLY_EMAILS_FAILED";
export const CLEAR_USER_STATE = "send-emails/CLEAR_USER_STATE";
export const SAVE_EMAIL_TEXT = "send-emails/SAVE_EMAIL_TEXT";
export const SAVE_EMAIL_TEXT_SUCCESS = "send-emails/SAVE_EMAIL_TEXT_SUCCESS";
export const UPDATE_EMAIL_TEXT = "send-emails/UPDATE_EMAIL_TEXT";
export const UPDATE_EMAIL_TEXT_SUCCESS =
  "send-emails/UPDATE_EMAIL_TEXT_SUCCESS";
export const GET_WEEKLY_EMAIL_TEXT = "send-emails/GET_WEEKLY_EMAIL_TEXT";
export const GET_WEEKLY_EMAIL_TEXT_SUCCESS =
  "send-emails/GET_WEEKLY_EMAIL_TEXT_SUCCESS";
